import { RESULTS_PER_PAGE } from "../../../utils/constants";

export const paramMap = {
  dateFrom: "start_at_after",
  dateTo: "end_at_before",
  flyerOwner: "owner",
};

export const defaultParams = {
  limit: [RESULTS_PER_PAGE],
  page: [1],
};
